import React, { useContext, useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../config/AuthContext";
import Login from "../../Login";
import { Content } from "antd/es/layout/layout";
import { GetJutgeProblemesId } from "../../../dao/jutge/GetJutgeProblemesId";
import AppSiderProblemesId from "./menus/AppSiderProblemesId";
import ProblemaIdEnunciat from "./content/ProblemaIdEnunciat";
import ProblemaIdExemples from "./content/ProblemaIdExemples";
import ProblemaIdEstadistiques from "./content/ProblemaIdEstadistiques";
import ProblemaIdAlumnes from "./content/ProblemaIdAlumnes";
import { FloatButton } from "antd";
import AvaluacioColors from "../../../styles/AvaluacioColors";
import { GetPractica } from "../../../dao/jutge/GetPracticaId";
import { GetUsuariIdJutgeActivitatsId } from "../../../dao/GetUsuariIdJutgeActivitatsId";
import { IoChatboxEllipsesOutline, IoInformationCircle } from "react-icons/io5";
import ChatModal from "../components/ChatModal";
import { GetUsuariIdActivitatIdProblemaIdAyuda } from "../../../dao/GetUsuariIdActivitatIdProblemaIdAyuda";
import { motion } from "framer-motion";
import ChatTableModal from "../components/ChatTableModal";
import UseWebSocketSubscription from "../../UseWebSocketSubscription";
import { GetJutgeUsuariIdJavamons } from "../../../dao/jutge/GetJutgeUsuariIdJavamons";
import { GetActivityJavamonStatus } from "../../../dao/jutge/GetActivityJavamonStatus";
import { GetUsuariIdJutgeActivitats } from "../../../dao/GetUsuariIdJutgeActivitats";
import { GetAlumneId } from "../../../dao/GetAlumneId";

const ProblemesId = () => {
    const { isLoggedIn, userId, user, setBreadCrumb, alumne } = useContext(AuthContext);
    const navigate = useNavigate();
    const { id_problema, id_activitat } = useParams();
    const [dades, setDades] = (useState<any>())
    const [pantalla, setPantalla] = useState(0);
    const [selectedRecord, setSelectedRecord] = useState<any>();
    const [activitat, setActivitat] = (useState<any>({ isExamen: true }))

    const [enviado, setEnviado] = useState(false);
    const [questionModal, setQuestionModal] = useState(false);
    const [tableModal, setTableModal] = useState(false);
    const [conversaModal, setConversaModal] = useState(false);
    const [loading, setLoading] = useState(true);
    const [idAulaActual, setIdAulaActual] = useState<string | null>(null);
    const MotionFloatButton = motion(FloatButton);

    useEffect(() => {
        if (isLoggedIn) {
            checkDades(true);
        }
    }, [id_problema]);

    UseWebSocketSubscription(
        [`/topic/activitat/${id_activitat}`],
        async (topic, msg) => {
            console.log(`Mensaje en ${topic}:`, msg);
            if (msg === true || msg.accion === "REFRESH") {
                const record = await GetUsuariIdActivitatIdProblemaIdAyuda(userId + "",
                    id_activitat + "", id_problema + "");
                setSelectedRecord(record);
            }
        }
    );

    async function checkDades(refresh: boolean) {
        setEnviado(true);
        if (refresh) setLoading(true);

        var acti: any;
        var act: any;
        const data = await GetJutgeProblemesId(id_problema + "", id_activitat || "0");
        if (id_activitat !== undefined) {
            act = await GetPractica(id_activitat + "");
            setDades(act);
            acti = await GetUsuariIdJutgeActivitatsId(userId + "", id_activitat + "");
            setActivitat(acti);

            // Resolve id_aula: try from practica object first, then from alumne activitats list
            let resolvedAula: string | null = act?.id_aula ? act.id_aula + "" : null;
            if (!resolvedAula) {
                let allActs = await GetUsuariIdJutgeActivitats(userId + "");
                // Defensive parse: backend may return JSON string instead of parsed array
                if (typeof allActs === "string") {
                    try { allActs = JSON.parse(allActs); } catch { allActs = []; }
                }
                const found = Array.isArray(allActs) ? allActs.find((a: any) => a.id + "" === id_activitat + "") : null;
                if (found?.id_aula) resolvedAula = found.id_aula + "";
            }
            console.log("[ProblemesId] resolvedAula:", resolvedAula, "| act?.id_aula:", act?.id_aula, "| id_activitat:", id_activitat);
            setIdAulaActual(resolvedAula);

            // Modo examen: si el aula está en modo examen, se bloquea el acceso a problemas de actividades regulares para alumnos
            if (user?.tipus === "2") {
                let userAulas = alumne?.aules || [];
                if ((!userAulas || userAulas.length === 0) && userId) {
                    try {
                        const al = await GetAlumneId(userId);
                        if (al?.aules) userAulas = al.aules;
                    } catch (e) {}
                }
                const targetAula = (userAulas || []).find((a: any) => String(a.id || a.id_aula) === String(resolvedAula));
                const isExamMode = targetAula && Boolean(targetAula.isExamen === 1 || targetAula.isExamen === true || targetAula.is_examen === 1 || targetAula.is_examen === true);
                if (isExamMode) {
                    navigate(-1);
                    return;
                }
            }

            // Security Check
            const javamons = await GetJutgeUsuariIdJavamons(userId + "");
            const status = await GetActivityJavamonStatus(id_activitat + "", userId + "");

            const currentProblem = acti.find((p: any) => p.id == id_problema);

            if (currentProblem) {
                const esDependenciaDeJuego = (ele: any) => {
                    const raw = ele?.depende;
                    if (raw === null || raw === undefined) return false;
                    return String(raw).split(",").map((s: string) => s.trim()).includes("-1");
                };

                const idsDependencia = (ele: any): string[] => {
                    const raw = ele?.depende;
                    if (raw === null || raw === undefined || raw === "" || raw === 0 || raw === "0") return [];
                    return String(raw).split(",").map((s: string) => s.trim()).filter((s: string) => /^\d+$/.test(s) && s !== "0");
                };

                const depCumplida = (ele: any) => {
                    if (["0", "1"].includes(user.tipus)) return true;
                    if (status?.candado?.some((c: any) => c.idProblema === ele.id)) return true;
                    if (!ele.depende) return true;

                    // Si tiene dependencia de juego, solo es accesible desde el contexto del juego
                    const fromGame = typeof window !== "undefined" && window.location.search.includes("fromGame=true");
                    const isInsideIframe = typeof window !== "undefined" && window.self !== window.top;
                    if (esDependenciaDeJuego(ele) && !fromGame && !isInsideIframe) {
                        return false;
                    }

                    const ids = idsDependencia(ele);
                    if (ids.length === 0) return true;

                    return ids.every((depId: string) => {
                        const parent = acti.find((e: any) => (e.id + "") === depId);
                        return !!parent && parent.progres >= 1;
                    });
                };

                const potAccedir = (ele: any) => {
                    const avui = new Date(ele.now);
                    const inici = ele.inici ? new Date(ele.inici) : null;
                    const final = ele.final ? new Date(ele.final) : null;
                    if (["0", "1"].includes(user.tipus)) return true;
                    if (!inici && !final) return true;
                    if (inici && !final) return avui >= inici;
                    if (!inici && final) return avui <= final;
                    if (inici && final) return avui >= inici && avui <= final;
                    return false;
                };

                if (!potAccedir(currentProblem) || !depCumplida(currentProblem)) {
                    navigate(`/jutge/activitats/${id_activitat}`);
                    return;
                }
            }
        }

        const isRole3 = String(user?.tipus) === "3";
        setBreadCrumb(
            id_activitat === undefined ? (
                isRole3 ? [
                    { nom: 'problemes', nav: '/jutge/problemes' },
                    { nom: `${data.nom}`, nav: `/jutge/problemes/${data.id}` }
                ] : [
                    { nom: 'Home', nav: '/home' },
                    { nom: 'jutge', nav: '/jutge' },
                    { nom: 'problemes', nav: '/jutge/problemes' },
                    { nom: `${data.nom}`, nav: `/jutge/problemes/${data.id}` }
                ]
            ) : [
                { nom: 'Home', nav: '/home' },
                { nom: 'jutge', nav: '/jutge' },
                { nom: 'activitats', nav: `/jutge/activitats` },
                { nom: `${act && act.nom}`, nav: `/jutge/activitats/${id_activitat}` },
                { nom: `problemes`, nav: `/jutge/activitats/${id_activitat}` },
                { nom: `${data.nom}`, nav: `/jutge/activitats/${id_activitat}/problemes/${data.id}` }
            ],
            true
        );
        setLoading(false);
        setEnviado(false);
    }

    function setPnt(value: number) {
        setPantalla(value);
    }

    async function openQuestionModal() {
        setQuestionModal(true);
        const record = await GetUsuariIdActivitatIdProblemaIdAyuda(userId + "", id_activitat + "", id_problema + "");
        // Enrich with id_aula and id_practica (= id_activitat) so ChatModal always has them
        setSelectedRecord({
            ...record,
            id_aula: record?.id_aula ?? idAulaActual ?? dades?.id_aula ?? "-1",
            id_practica: record?.id_practica ?? (id_activitat ? parseInt(id_activitat) : undefined)
        });
    }

    async function openTableModal() {
        setTableModal(true);
        const record = await GetUsuariIdActivitatIdProblemaIdAyuda(userId + "", id_activitat + "", id_problema + "");
        setSelectedRecord({
            ...record,
            id_aula: record?.id_aula ?? idAulaActual ?? dades?.id_aula ?? "-1",
            id_practica: record?.id_practica ?? (id_activitat ? parseInt(id_activitat) : undefined)
        });
    }

    if (isLoggedIn) {
        return (
            <>
                {loading ? (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh', width: '100%' }}>
                        {/* Optional Spinner */}
                    </div>
                ) : (
                    <>
                        <AppSiderProblemesId setPantalla={setPnt} />
                        <Content style={{ padding: '0 24px', minHeight: 280 }}>
                            {pantalla === 0 && <ProblemaIdEnunciat />}
                            {pantalla === 1 && <ProblemaIdExemples />}
                            {pantalla === 2 && <ProblemaIdEstadistiques isConcurs={dades?.is_concurs === 1} />}
                            {pantalla === 3 && <ProblemaIdAlumnes />}
                        </Content>
                        {/* && (dades?.ia || dades?.colab) */}
                        {id_activitat !== undefined && !loading && dades?.isExamen !== 1 &&
                            !questionModal && selectedRecord?.newchat !== 1 ?
                            <FloatButton
                                shape="circle"
                                type="primary"
                                onClick={() => openQuestionModal()}
                                style={{ right: 80, bottom: 24, color: AvaluacioColors.colors.color6 }}
                                icon={<IoChatboxEllipsesOutline />}
                            />
                            : <></>}
                        {/* && (dades?.ia || dades?.colab) */}
                        {id_activitat !== undefined && !loading && dades?.isExamen !== 1
                            && selectedRecord?.newchat === 1 && !questionModal ? (
                            <MotionFloatButton
                                shape="circle"
                                type="primary"
                                onClick={() => openQuestionModal()}
                                style={{
                                    right: 80,
                                    bottom: 24,
                                    color: AvaluacioColors.colors.color6
                                }}
                                icon={<IoChatboxEllipsesOutline />}
                                animate={{
                                    scale: [1, 1.1, 1],
                                    boxShadow: [
                                        "0 0 0 0 rgba(255,87,34,0.6)",
                                        "0 0 0 15px rgba(255,87,34,0)",
                                        "0 0 0 0 rgba(255,87,34,0)"
                                    ]
                                }}
                                transition={{
                                    duration: 1.5,
                                    repeat: Infinity,
                                    ease: "easeInOut"
                                }}
                            />
                        ) : <></>}
                        {id_activitat !== undefined && !loading && dades?.isExamen !== 1 && dades?.colab
                            && selectedRecord?.helpchat > 0 && !tableModal ? (
                            <MotionFloatButton
                                shape="circle"
                                type="primary"
                                onClick={() => openTableModal()}
                                style={{
                                    right: 94,
                                    bottom: 24,
                                    color: AvaluacioColors.colors.color6
                                }}
                                icon={<IoInformationCircle />}
                                animate={{
                                    scale: [1, 1.1, 1],
                                    boxShadow: [
                                        "0 0 0 0 rgba(255,87,34,0.6)",
                                        "0 0 0 15px rgba(255,87,34,0)",
                                        "0 0 0 0 rgba(255,87,34,0)"
                                    ]
                                }}
                                transition={{
                                    duration: 1.5,
                                    repeat: Infinity,
                                    ease: "easeInOut"
                                }}
                            />
                        ) : <></>}

                        {id_activitat !== undefined && questionModal &&
                            <ChatModal
                                practica={true}
                                modalVisible={questionModal}
                                setModalVisible={() => setQuestionModal(false)}
                                selectedRecord={selectedRecord}
                            />
                        }
                        {id_activitat !== undefined && tableModal &&
                            <ChatTableModal
                                visible={tableModal}
                                isProblema={true}
                                onClose={() => {
                                    setTableModal(false);
                                    checkDades(false);
                                }}
                                aula={{ id: selectedRecord?.id_aula }}
                            />
                        }
                    </>
                )}
            </>
        );
    } else {
        return (
            <Login />
        );
    }
};
export default ProblemesId;
